module.exports = __webpack_public_path__ + "img/0Q3A7250_P_L_Foamcore_MockedUp.61f5a739.jpg";